export default "__VITE_ASSET__DFuxMxta__"